<template>
  <div class="setBox_wrap alarm">
    <div class="alram_setBox">
      <h5>{{ $t("alarm['alertOnOff']") }}</h5>
      <div class="alarmchk_toggle">
        <label class="toggle-switch">
          <input 
            type="checkbox" 
            v-model="activeChk" 
            @change="chgActive" 
          />
          <span class="slider-toggle"></span>
        </label>
      </div>
    </div>
    
    <div class="right_set_sound" :class="subPath == 'support-resistance' || subPath == 'light' || subPath === 'rocket' ? 'support' : ''">
      <div class="selectBox alarm" :class="[locale, { 'checked': selectShow }]" @click="openAlarmList">
        <a id="soundVal">
          {{ seletedSound }}
        </a>
      </div>
      <transition name="fade">
        <div class="sound-list-container" v-if="selectShow">
          <div v-for="(sound, soundId) in alarmList" :key="soundId" :class="seletedSound == sound ? 'selected' : ''">
            <a @click="chgSound(soundId + 1)">{{ sound }}</a>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { defineProps, computed, ref, watch, toRef, defineEmits } from "vue";

import apiAlarm from "@/api/apiAlarm.js"

const route = useRoute();
const subPath = ref(route.path.split('/')[2])

const { t, locale } = useI18n();


const props = defineProps({
  alarmStatus: Object,
  routeName: String,
  alarmList: Array
});

// ======= 유저가 기존 선택한 알람 상태 적용 =======
const alarmStatus = computed(() => props.alarmStatus);
const alarmList = computed(() => props.alarmList);

// 토글과 연결된 반응형 변수
const activeChk = ref(false); 
const seletedSound = ref('');

watch(alarmStatus, (newVal) => {
  if (newVal) {
    activeChk.value = newVal.active;
    if (newVal.filename == 'default') {
      seletedSound.value = t('alarm.price.default');
    }
    else {
      let soundNum = newVal.display.split(' ')[2]
      seletedSound.value = t('alarm.price.soundFormat', { number: soundNum })
    }
  }
}, { immediate: true });

watch(alarmList, (newVal) => {
  if (newVal) {
    alarmList.value = newVal
  }
}, { immediate: true });
// ======= 끝 =======



// ======= 알람 리스트 드롭다운 상태관리 =======
const selectShow = ref(false);

function openAlarmList() {
  selectShow.value = !selectShow.value;
}
// ======= 끝 =======



// ======= 알람음 변경 api =======
const emit = defineEmits(["getChangedStatus"]);
const path = toRef(props, 'routeName');

async function chgSound(soundId) {
  await apiAlarm.patchSound(path.value + '/sound/' + soundId)
  emit("getChangedStatus");
  openAlarmList();

  let adjustedSoundId = soundId - 1; // Adjust soundId to match the index in the alarmList

  // iOS (WKWebView)
  if (window.webkit?.messageHandlers?.soundSelected) {
    window.webkit.messageHandlers.soundSelected.postMessage(adjustedSoundId);
  }
  // Android (injected JS interface)
  if (window.Android?.soundSelected) {
    window.Android.soundSelected(adjustedSoundId);
  }
}
// ======= 끝 =======



// ======= 토글 ON/OFF 변경 api =======
async function chgActive() {
  // activeChk.value는 v-model에 의해 이미 반전된 상태이므로 값만 서버로 보냅니다.
  await apiAlarm.patchSound(path.value + '/active/' + activeChk.value);
}
// ======= 끝 =======

</script>

<style scoped>
/* 드롭다운 리스트 스타일 유지 */
.sound-list-container {
  color: var(--Main);
  font-family: "Poppins", sans-serif, "Sawarabi Gothic", sans-serif, "LXGW WenKai TC", cursive;;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;
  text-transform: capitalize;
  height: 250px;
  margin-top: 8px;

  display: flex;
  flex-direction: column;
  overflow-y: auto;
  font-size: 13px;
  border-radius: 8px;
  border: 1px solid #2C2C2C;
  background: #222223;
  box-shadow: 0 6px 4px 0 rgba(0, 0, 0, 0.25);
}

.sound-list-container>div {
  padding: 15px 10px;
  z-index: 30;
}

.selected {
  background: url("@/assets/images/icon/common/check-orange.png") right 10px center no-repeat;
  background-size: 18px;
  color: var(--btn-primary-bgcolor);
}

.checked {
  border: 1px solid var(--btn-primary-bgcolor) !important;
}

/* ==========================================
   커스텀 토글 스위치 스타일 (수정 및 보완) 
   ========================================== */

/* 1. 토글 스위치 컨테이너 */
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 38px; /* 너비 조절 */
  height: 18px; /* 높이 조절 */
  margin-left: auto; /* 우측 정렬이 필요하다면 사용 */
}

/* 2. 실제 체크박스는 완전히 숨김 (클릭 영역은 label이 대신 받음) */
.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
}

/* 3. 토글 배경 (OFF 상태) */
.slider-toggle {
  position: absolute;
  cursor: pointer;
  top: 0; 
  left: 0; 
  right: 0; 
  bottom: 0;
  background: #222223; /* 이미지와 비슷한 어두운 배경색 */
  border: 1px solid #3B3B3B;
  border-radius: 24px; /* 둥근 모서리 */
  transition: background-color 0.3s ease;
}

/* 4. 토글 동그라미 (OFF 상태) */
.slider-toggle:before {
  position: absolute;
  content: "";
  height: 16px; /* 배경보다 살짝 작게 */
  width: 16px;
  top: 0px;
  left: 0px; /* 왼쪽 여백 */
  bottom: 1px; /* 위아래 중앙을 맞추기 위한 하단 여백 */
  background-color: #D4D4D4; /* 이미지의 OFF 상태 동그라미 색상 */
  border-radius: 50%;
  transition: transform 0.3s ease, background-color 0.3s ease;
}

/* 6. 토글 동그라미 (ON 상태) */
.toggle-switch input:checked + .slider-toggle:before {
  transform: translateX(20px); 
  background-color: var(--btn-primary-bgcolor); 
}

/* 모바일 반응형 유지 */
@media (max-width: 400px) {
  .sound-list-container {
    font-size: 12px;
  }

  .sound-list-container>div {
    font-weight: 400;
  }

  .selected {
    font-weight: 400;
    background-size: 18px;
  }
}
</style>